/**
 * Integrytas Base App · MOBILE primitive
 * Status pill (Direction C) — 11/700 pill with a leading dot, semantic tones.
 * The label must be already-resolved/localized display text (§17.B4/B11), never
 * a raw code.
 */
import type { ReactNode } from 'react';

export type MobilePillTone = 'ok' | 'no' | 'wait' | 'you' | 'info';

const PILL_TONE: Record<MobilePillTone, string> = {
  ok: 'm-p-ok', no: 'm-p-no', wait: 'm-p-wait', you: 'm-p-you', info: 'm-p-info',
};

interface MobileStatusPillProps {
  tone: MobilePillTone;
  children: ReactNode;
}

export function MobileStatusPill({ tone, children }: MobileStatusPillProps) {
  return <span className={'m-pill ' + PILL_TONE[tone]}>{children}</span>;
}
